<app-header-new></app-header-new>
<app-aside-menu-new></app-aside-menu-new>
<router-outlet (activate)="onActivate()"></router-outlet>
<app-footer></app-footer>
<app-button-go-top-new></app-button-go-top-new>
